// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

/*수첩 기록*/
.record {width: calc(100% - 619px);}

.record .info{
    border-radius: 10px;
    height: 50px;
    background: #fff;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    display: flex;
    font-size: 14px;
    align-items: center;
    padding: 0 20px;
    gap:15px;
}
.record .info .guardian{margin-left: auto;}
.record .info .tit{color: #51D7DF;margin-right: 5px;}

.note{
    width: 100%;
    height: 686px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    margin-top: 17px;
    padding: 16px 28px 21px 26px;
    box-sizing: border-box;
}

.note.disabled {
    opacity: 0.3; /* 흐리게 표시 */
    pointer-events: none; /* 사용자 입력 방지 */
}

.note .tit{
    font-size: 18px;
    font-weight: 700;
}

.register{
    border-radius: 20px;
    border: 1px solid #EBEBEB;
    padding: 15px 28px 17px 25px;
    box-sizing: border-box;
}

.register .diagnosis .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;}
.register .diagnosis .top .tit { width: 100px;}
.register .diagnosis .option{
    display: inline-flex;
    padding: 4px 10px;
    align-items: center;
    border-radius: 20px;
    background: #EDEDED;
}
.register .diagnosis div .option { /* 제목 */ margin-left:20px; }
.register .diagnosis .option label:first-child {
    width: 30px;
}
.register .diagnosis .option .title{
    width:180px;
    text-align: left;   
    margin: 0; /* 불필요한 마진 제거 */
    line-height: 1; /* 라인 높이 조정 */
    height: 20px; /* 필요한 경우 높이 직접 지정 */
}

.register .diagnosis .create_btn {
    width:130px;
    height:35px;
    border-radius: 5px;
    border: none;
    background: #51D7DF;
    color: #FFF;
    font-size: 16px;
    font-weight: 400;
    margin-right:10px;
}

.register .diagnosis .topper {
    display: inline-flex;
    align-items: center; /* 세로 중앙 정렬 */
    margin-bottom:10px;
}

.timer {
    display: inline-flex;
    align-items: center; /* 세로 중앙 정렬 */
    margin-right: 10px;
}

.timer label { 
    align-items: center;
    display:flex;
    margin-right: 15px;
    gap:5px;
}

.time_container{
    width: 150px;
    align-items: center;
    text-align: center;
    margin-right: 5px; /* 라벨과 인풋 사이의 여백 */
    border-radius: 20px;
    font-size:12px;
    background: #EDEDED;
    padding:4px 5px;
}

.register .diagnosis .btm{
    display: flex;
    margin-top: 10px;
    justify-content: center;
}
.register .diagnosis .btm button {
    width:187px;
    height:48px;
    background:#51D7DF20;
    font-size:14px;
    font-style:bold;
    color: #51D7DF;
    border-radius: 12px;
    border : 2px dashed #51D7DF;
}

#round_btn {
    width:90px;
    height:30px;
    background: #51D7DF;
    font-size: 18px;
    color: #FFF;
    border-radius: 20px;
    border: none;
    margin-right:10px;
    margin-bottom:10px;
}

.form_container {
    width: 100%;
    height: 315px;
    display: flex;
    flex-direction: column; /* 세로 정렬 */
    align-items: center; /* 수평 중앙 정렬 */
    overflow-y: scroll;
    overflow-x: hidden;
}

.register_form {
    width: 98%;
    background: white;
    border: 1px solid #EDEDED;
    border-radius: 20px;
    margin-bottom: 20px;
}

.register_form .timer { margin-left:10px; margin-top:10px;}

.register_form .timer input {    
    width: 150px;
    align-items: center;
    text-align: center;
    
    margin-right: 5px; /* 라벨과 인풋 사이의 여백 */
    border-radius: 20px;
    font-size:12px;
    background: #FFFFFF;
    padding:4px 5px;
}
.register_form .texter {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}
.register_form .texter textarea {
    border: none;
    width: 100%;
    height: 98px;
    resize: none;
    font-size: 14px;
    color:#353535;
    background:transparent;
    margin:10px;
}

.register_form .texter textarea::placeholder {
    color: #ABABAB;
    font-size: 14px;
}

.register_form .bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.btn_box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.add_box {display: flex; gap: 14px; margin-left:20px;margin-bottom:10px; }
.add_box label[for="add_file"]{
    display: flex;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    border: 1px dashed #C4C4C4;
    align-items: center;
    justify-content: center;
}
#add_file{display: none;}

.preview{
     width: 70px;
    height: 70px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}
.preview img{width: inherit; height:100%; object-fit: cover;}
.preview .delete_btn{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background: #000;
    position: absolute; top: 0; right: 0;
    z-index: 10;
}
.imgs .btm button{
    position: absolute; right: 0; bottom: 0;
    display: flex;
    width: 90px;
    height: 30px;
    padding: 11px 14px;
    justify-content: center;
    align-items: center;
    border-radius: 21px;
    border: 1px solid #51D7DF;
    background: #51D7DF;
    color: #fff;
    font-size: 18px;
}
.history {margin-top: 20px;}
.history ul{ width: 99%; height: 150px; overflow-y: scroll; margin: 18px auto 0;}
.history ul li{
    height: 70px;
    border-radius: 10px;
    background: #FFF;
    border: 1px solid #ebebeb;
    margin-bottom: 10px;
    padding: 8px 24px;
    margin-left:10px;
    margin-right:10px;
    box-sizing: border-box;
}
.history ul li div{
    display: flex;
    gap:30px; 
    align-items: center;
    justify-content: space-between;}

.history ul li .top {
    color: #ABABAB;
}

.history .chkup_con{
    margin-top: 3px;
    font-size: 16px;
    font-weight: 500;
}

.history .regis_insu {
    font-size: 18px;
    text-decoration: underline;
}

/*채팅방*/
.chat{width: 295px;}
.chatting_box{
    width: 100%;
    height: 701px;
    border-radius: 20px;
    background: #F4FFFE;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    position: relative;
    text-align: center;
}
.chat_date{
    display: inline-flex;
    padding: 3px 9px;
    border-radius: 5px;
    background: #E7ECEC;
    color: #777;
    text-align: center;
    margin: 14px auto 18px;
    font-size: 12px;
}
.msg_box{
    margin: 5px 0;
}
.sender{
    text-align: left;
    margin-left: 15px;
}
.receiver{
    text-align: right;
    margin-right: 15px;
}
.file_box{
    text-align: right;
    margin-right: 15px;
}
.msg_box .name{
    font-size: 13px;
    font-weight: 500;
    display: block;
}
.msg_box .msg {
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    max-width:60%;
}
.msg_box .msg .message {
    width:100%;
    word-wrap: break-word; /* 긴 단어가 있을 경우 줄바꿈 */
    word-break: break-word; /* 긴 단어가 있을 경우 줄바꿈 */
    white-space: pre-wrap; /* 공백을 유지하고 줄바꿈 */
}

.msg_box .images {
    display: flex;
    gap: 5px;
    margin-top: 5px;
}

.sender .msg{
    margin: 4px 0 0;
    display: inline-flex;
    padding: 6px 9px 8px 9px;
    justify-content: center;
    align-items: center;
    border-radius: 10px 10px 10px 0px;
    background: #DCFDFF;
    font-size: 14px;
}
.msg_date{
    color: #9A9A9A;
    font-size: 12px;
    font-weight: 400;
}
.receiver .msg{
    margin: 4px 0 0;
    display: inline-flex;
    padding: 6px 9px 8px 9px;
    justify-content: center;
    align-items: center;
    border-radius: 10px 10px 0px 10px;
    background: #51D7DF;
    font-size: 14px;
    color: #fff;
}
.file_box .msg{
    margin: 4px 0 0;
    display: inline-flex;
    padding: 6px 9px 8px 9px;
    justify-content: center;
    align-items: center;
    border-radius: 10px 10px 0px 10px;
    background: #51D7DF;
    font-size: 14px;
    color: #fff;
    gap: 6px;
}

.chat_write_msg{
    width: 100%;
    border-radius: 0 0 20px 20px;
    background: #fff;
    position: absolute;
    bottom: 0;
}
.attach_list{
    display: none;
    padding: 19px 28px; border-bottom: 1px solid #ECECEC;
}
.attach_list ul{
    display: flex;justify-content: space-between;
}
.attach_list ul li{width: 18%; display:flex; align-items: center; }
.attach_list ul li label span{display: block; margin: auto;}
.attach_list input{width: 0px;}
.attach_list ul li label .icon{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    border-radius: 15px;
    background: #51D7DF;
}

.chatting_box .con{ 
    padding: 7px 10px;
    max-height: 530px;
    overflow-y: auto;
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
}

.chatting_box .con .attachBox {
    display: flex;
    align-items: center;
}

.chatting_box .con .image_attach img {
    height: 100%;
    border: 1px solid #ECECEC;
    border-radius: 5px;
}
/* Chrome, Safari, and newer browsers */
.chatting_box .con::-webkit-scrollbar {
    display: none; /* This is for Chrome, Safari and newer browsers */
}

.chat_write_msg .attach{ vertical-align: bottom;}

.chat_write_msg textarea{
    border: none;
    width: 233px;
    height: 98px;
    resize: none;
    font-size: 14px;
}

.chat_write_msg .send_btn{
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 18px;
    background: #51D7DF;
}
.chat_write_msg .send_btn svg{
    position: relative;
    right: -1px;
}`, "",{"version":3,"sources":["webpack://./src/css/note.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,QAAQ;AACR,SAAS,yBAAyB,CAAC;;AAEnC;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAER,sDAAsD;IAG9D,aAAa;IACb,eAAe;IAGP,mBAAmB;IAC3B,eAAe;IACf,QAAQ;AACZ;AACA,wBAAwB,iBAAiB,CAAC;AAC1C,mBAAmB,cAAc,CAAC,iBAAiB,CAAC;;AAEpD;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,sDAAsD;IAC9D,gBAAgB;IAChB,4BAA4B;IAEpB,sBAAsB;AAClC;;AAEA;IACI,YAAY,EAAE,WAAW;IACzB,oBAAoB,EAAE,cAAc;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAEpB,sBAAsB;AAClC;;AAEA;IAGI,aAAa;IAGb,mBAAmB;IAGnB,8BAA8B;IAC9B,mBAAmB,CAAC;AACxB,iCAAiC,YAAY,CAAC;AAC9C;IAGI,oBAAoB;IACpB,iBAAiB;IAGT,mBAAmB;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;AACA,mCAAmC,OAAO,EAAE,gBAAgB,EAAE;AAC9D;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS,EAAE,eAAe;IAC1B,cAAc,EAAE,aAAa;IAC7B,YAAY,EAAE,oBAAoB;AACtC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IAGI,oBAAoB;IACpB,mBAAmB,EAAE,aAAa;IAClC,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB,EAAE,aAAa;IAClC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB,EAAE,kBAAkB;IACrC,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IAGI,aAAa;IACb,gBAAgB;IAGhB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB,EAAE,UAAU;IAClC,mBAAmB,EAAE,aAAa;IAClC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,wBAAwB,gBAAgB,EAAE,eAAe,CAAC;;AAE1D;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;;IAElB,iBAAiB,EAAE,kBAAkB;IACrC,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA,UAAqD,aAAa,EAAE,SAAS,EAAE,gBAAgB,CAAC,kBAAkB,EAAE;AACpH;IAGI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAGlB,mBAAmB;IAGnB,uBAAuB;AACnC;AACA,UAAU,aAAa,CAAC;;AAExB;KACK,WAAW;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA,aAAa,cAAc,EAAE,WAAW,EAAE,iBAAiB,CAAC;AAC5D;IAGI,aAAa;IAGL,mBAAmB;IAGnB,uBAAuB;IAC/B,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB,EAAE,MAAM,EAAE,QAAQ;IACpC,WAAW;AACf;AACA;IACI,kBAAkB,EAAE,QAAQ,EAAE,SAAS;IAGvC,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAGV,uBAAuB;IAGvB,mBAAmB;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;AACA,UAAU,gBAAgB,CAAC;AAC3B,aAAa,UAAU,EAAE,aAAa,EAAE,kBAAkB,EAAE,mBAAmB,CAAC;AAChF;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IAET,sBAAsB;AAClC;AACA;IAGI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,8BAA8B,CAAC;;AAEnC;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA,MAAM;AACN,MAAM,YAAY,CAAC;AACnB;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IAEX,sDAAsD;IAC9D,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IAGI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,UAAU;IACV,qBAAqB,EAAE,oBAAoB;IAC3C,sBAAsB,EAAE,oBAAoB;IAC5C,qBAAqB,EAAE,iBAAiB;AAC5C;;AAEA;IAGI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IAGf,oBAAoB;IACpB,wBAAwB;IAGhB,uBAAuB;IAGvB,mBAAmB;IAC3B,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IAGf,oBAAoB;IACpB,wBAAwB;IAGhB,uBAAuB;IAGvB,mBAAmB;IAC3B,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IAGf,oBAAoB;IACpB,wBAAwB;IAGhB,uBAAuB;IAGvB,mBAAmB;IAC3B,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,aAAa;IACb,kBAAkB,EAAE,gCAAgC;AACxD;AACA;IAGI,aAAa,CAAkD,8BAA8B;AACjG;AACA,mBAAmB,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAClE,8BAA8B,cAAc,EAAE,YAAY,CAAC;AAC3D,mBAAmB,UAAU,CAAC;AAC9B;IAGI,aAAa;IAGL,uBAAuB;IAGvB,mBAAmB;IAC3B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB,EAAE,gBAAgB;IACvC,wBAAwB,EAAE,mCAAmC;AACjE;;AAEA;IAGI,aAAa;IAIL,mBAAmB;AAC/B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA,uCAAuC;AACvC;IACI,aAAa,EAAE,kDAAkD;AACrE;;AAEA,yBAAyB,sBAAsB,CAAC;;AAEhD;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IAGZ,aAAa;IAGL,uBAAuB;IAGvB,mBAAmB;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["@charset \"utf-8\";\n\n/*수첩 기록*/\n.record {width: calc(100% - 619px);}\n\n.record .info{\n    border-radius: 10px;\n    height: 50px;\n    background: #fff;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 14px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 20px;\n    gap:15px;\n}\n.record .info .guardian{margin-left: auto;}\n.record .info .tit{color: #51D7DF;margin-right: 5px;}\n\n.note{\n    width: 100%;\n    height: 686px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    margin-top: 17px;\n    padding: 16px 28px 21px 26px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n\n.note.disabled {\n    opacity: 0.3; /* 흐리게 표시 */\n    pointer-events: none; /* 사용자 입력 방지 */\n}\n\n.note .tit{\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.register{\n    border-radius: 20px;\n    border: 1px solid #EBEBEB;\n    padding: 15px 28px 17px 25px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n\n.register .diagnosis .top {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    margin-bottom: 15px;}\n.register .diagnosis .top .tit { width: 100px;}\n.register .diagnosis .option{\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 4px 10px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 20px;\n    background: #EDEDED;\n}\n.register .diagnosis div .option { /* 제목 */ margin-left:20px; }\n.register .diagnosis .option label:first-child {\n    width: 30px;\n}\n.register .diagnosis .option .title{\n    width:180px;\n    text-align: left;   \n    margin: 0; /* 불필요한 마진 제거 */\n    line-height: 1; /* 라인 높이 조정 */\n    height: 20px; /* 필요한 경우 높이 직접 지정 */\n}\n\n.register .diagnosis .create_btn {\n    width:130px;\n    height:35px;\n    border-radius: 5px;\n    border: none;\n    background: #51D7DF;\n    color: #FFF;\n    font-size: 16px;\n    font-weight: 400;\n    margin-right:10px;\n}\n\n.register .diagnosis .topper {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    align-items: center; /* 세로 중앙 정렬 */\n    margin-bottom:10px;\n}\n\n.timer {\n    display: inline-flex;\n    align-items: center; /* 세로 중앙 정렬 */\n    margin-right: 10px;\n}\n\n.timer label { \n    align-items: center;\n    display:flex;\n    margin-right: 15px;\n    gap:5px;\n}\n\n.time_container{\n    width: 150px;\n    align-items: center;\n    text-align: center;\n    margin-right: 5px; /* 라벨과 인풋 사이의 여백 */\n    border-radius: 20px;\n    font-size:12px;\n    background: #EDEDED;\n    padding:4px 5px;\n}\n\n.register .diagnosis .btm{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-top: 10px;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n.register .diagnosis .btm button {\n    width:187px;\n    height:48px;\n    background:#51D7DF20;\n    font-size:14px;\n    font-style:bold;\n    color: #51D7DF;\n    border-radius: 12px;\n    border : 2px dashed #51D7DF;\n}\n\n#round_btn {\n    width:90px;\n    height:30px;\n    background: #51D7DF;\n    font-size: 18px;\n    color: #FFF;\n    border-radius: 20px;\n    border: none;\n    margin-right:10px;\n    margin-bottom:10px;\n}\n\n.form_container {\n    width: 100%;\n    height: 315px;\n    display: flex;\n    flex-direction: column; /* 세로 정렬 */\n    align-items: center; /* 수평 중앙 정렬 */\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.register_form {\n    width: 98%;\n    background: white;\n    border: 1px solid #EDEDED;\n    border-radius: 20px;\n    margin-bottom: 20px;\n}\n\n.register_form .timer { margin-left:10px; margin-top:10px;}\n\n.register_form .timer input {    \n    width: 150px;\n    align-items: center;\n    text-align: center;\n    \n    margin-right: 5px; /* 라벨과 인풋 사이의 여백 */\n    border-radius: 20px;\n    font-size:12px;\n    background: #FFFFFF;\n    padding:4px 5px;\n}\n.register_form .texter {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.register_form .texter textarea {\n    border: none;\n    width: 100%;\n    height: 98px;\n    resize: none;\n    font-size: 14px;\n    color:#353535;\n    background:transparent;\n    margin:10px;\n}\n\n.register_form .texter textarea::placeholder {\n    color: #ABABAB;\n    font-size: 14px;\n}\n\n.register_form .bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n.btn_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n.add_box { display: -webkit-box;display: -ms-flexbox;display: flex; gap: 14px; margin-left:20px;margin-bottom:10px; }\n.add_box label[for=\"add_file\"]{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 70px;\n    height: 70px;\n    border-radius: 10px;\n    border: 1px dashed #C4C4C4;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n#add_file{display: none;}\n\n.preview{\n     width: 70px;\n    height: 70px;\n    border-radius: 10px;\n    overflow: hidden;\n    position: relative;\n}\n.preview img{width: inherit; height:100%; object-fit: cover;}\n.preview .delete_btn{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 20px;\n    height: 20px;\n    background: #000;\n    position: absolute; top: 0; right: 0;\n    z-index: 10;\n}\n.imgs .btm button{\n    position: absolute; right: 0; bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 90px;\n    height: 30px;\n    padding: 11px 14px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 21px;\n    border: 1px solid #51D7DF;\n    background: #51D7DF;\n    color: #fff;\n    font-size: 18px;\n}\n.history {margin-top: 20px;}\n.history ul{ width: 99%; height: 150px; overflow-y: scroll; margin: 18px auto 0;}\n.history ul li{\n    height: 70px;\n    border-radius: 10px;\n    background: #FFF;\n    border: 1px solid #ebebeb;\n    margin-bottom: 10px;\n    padding: 8px 24px;\n    margin-left:10px;\n    margin-right:10px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.history ul li div{\n    display: -webkit-box; \n    display: -ms-flexbox;\n    display: flex;\n    gap:30px; \n    align-items: center;\n    justify-content: space-between;}\n\n.history ul li .top {\n    color: #ABABAB;\n}\n\n.history .chkup_con{\n    margin-top: 3px;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.history .regis_insu {\n    font-size: 18px;\n    text-decoration: underline;\n}\n\n/*채팅방*/\n.chat{width: 295px;}\n.chatting_box{\n    width: 100%;\n    height: 701px;\n    border-radius: 20px;\n    background: #F4FFFE;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    position: relative;\n    text-align: center;\n}\n.chat_date{\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 3px 9px;\n    border-radius: 5px;\n    background: #E7ECEC;\n    color: #777;\n    text-align: center;\n    margin: 14px auto 18px;\n    font-size: 12px;\n}\n.msg_box{\n    margin: 5px 0;\n}\n.sender{\n    text-align: left;\n    margin-left: 15px;\n}\n.receiver{\n    text-align: right;\n    margin-right: 15px;\n}\n.file_box{\n    text-align: right;\n    margin-right: 15px;\n}\n.msg_box .name{\n    font-size: 13px;\n    font-weight: 500;\n    display: block;\n}\n.msg_box .msg {\n    display:flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width:60%;\n}\n.msg_box .msg .message {\n    width:100%;\n    word-wrap: break-word; /* 긴 단어가 있을 경우 줄바꿈 */\n    word-break: break-word; /* 긴 단어가 있을 경우 줄바꿈 */\n    white-space: pre-wrap; /* 공백을 유지하고 줄바꿈 */\n}\n\n.msg_box .images {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 5px;\n    margin-top: 5px;\n}\n\n.sender .msg{\n    margin: 4px 0 0;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 6px 9px 8px 9px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 10px 10px 10px 0px;\n    background: #DCFDFF;\n    font-size: 14px;\n}\n.msg_date{\n    color: #9A9A9A;\n    font-size: 12px;\n    font-weight: 400;\n}\n.receiver .msg{\n    margin: 4px 0 0;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 6px 9px 8px 9px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 10px 10px 0px 10px;\n    background: #51D7DF;\n    font-size: 14px;\n    color: #fff;\n}\n.file_box .msg{\n    margin: 4px 0 0;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 6px 9px 8px 9px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 10px 10px 0px 10px;\n    background: #51D7DF;\n    font-size: 14px;\n    color: #fff;\n    gap: 6px;\n}\n\n.chat_write_msg{\n    width: 100%;\n    border-radius: 0 0 20px 20px;\n    background: #fff;\n    position: absolute;\n    bottom: 0;\n}\n.attach_list{\n    display: none;\n    padding: 19px 28px; border-bottom: 1px solid #ECECEC;\n}\n.attach_list ul{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;-webkit-box-pack: justify;-ms-flex-pack: justify;justify-content: space-between;\n}\n.attach_list ul li{width: 18%; display:flex; align-items: center; }\n.attach_list ul li label span{display: block; margin: auto;}\n.attach_list input{width: 0px;}\n.attach_list ul li label .icon{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 38px;\n    height: 38px;\n    border-radius: 15px;\n    background: #51D7DF;\n}\n\n.chatting_box .con{ \n    padding: 7px 10px;\n    max-height: 530px;\n    overflow-y: auto;\n    scrollbar-width: none; /* For Firefox */\n    -ms-overflow-style: none; /* For Internet Explorer and Edge */\n}\n\n.chatting_box .con .attachBox {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n\n.chatting_box .con .image_attach img {\n    height: 100%;\n    border: 1px solid #ECECEC;\n    border-radius: 5px;\n}\n/* Chrome, Safari, and newer browsers */\n.chatting_box .con::-webkit-scrollbar {\n    display: none; /* This is for Chrome, Safari and newer browsers */\n}\n\n.chat_write_msg .attach{ vertical-align: bottom;}\n\n.chat_write_msg textarea{\n    border: none;\n    width: 233px;\n    height: 98px;\n    resize: none;\n    font-size: 14px;\n}\n\n.chat_write_msg .send_btn{\n    position: absolute;\n    right: 10px;\n    bottom: 10px;\n    width: 36px;\n    height: 36px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 18px;\n    background: #51D7DF;\n}\n.chat_write_msg .send_btn svg{\n    position: relative;\n    right: -1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
